export const hasValues = (value = []) => value.some(_value => _value.number.length !== 0);
